import {
  ON_CLICK_MEDIA,
  SET_EXPAND_STATE,
  UPDATE_STORY_PROGRESS,
  SET_APP_STATE,
  SET_POSTS,
  SET_STORIES,
  ON_TEXT_CHANGE,
} from '../../constants';
import { GALLERY_TYPES } from '../../constants/proGalleryConstants';
import { SORT_HASHTAG_OPTIONS } from '../../constants/settingsConstants';
import { getMediaLinks } from '../services/linksService';
import { getCommentsByMediaId } from '../services/commentsService';
import { loadMoreMedias } from './expandLoadMore';
import store from '../../store';
import { EXPAND_PARAMS, isInstagramV4 } from '../more/migration';

const DEMO_STORIES = require('../templates/demoStories.json');

export const setPosts = () => ({
  type: SET_POSTS,
});

export const setStories = () => ({
  type: SET_STORIES,
});

export const openExpandMedia = ({
  eData = { idx: 0 },
  type = GALLERY_TYPES.FEED,
  isNewWindow = true,
  route = 'expand',
}) => async () => {
  const storeState = store.getState();
  const {
    accessToken,
    userId,
    isBusinessApp,
    medias,
    user,
    hashtagsData,
    paginationMedias,
    hashtags,
    defaultHashtags,
    stories,
    isConnected,
  } = storeState.appReducer;
  const mediasByType = {
    [GALLERY_TYPES.HASHTAG]: hashtagsData,
    [GALLERY_TYPES.FEED]: medias,
    [GALLERY_TYPES.STORY]:
      stories && stories.length
        ? stories
            .map((media) => ({
              ...media,
              progress: 0,
            }))
            .reverse()
        : DEMO_STORIES,
  };
  const pageByType = {
    [GALLERY_TYPES.HASHTAG]: hashtags.length === 0 ? defaultHashtags : hashtags,
    [GALLERY_TYPES.FEED]: paginationMedias,
    [GALLERY_TYPES.STORY]: {},
  };
  const { sortHashtagsFeed } = storeState.settingsReducer;
  const isRecent = sortHashtagsFeed === SORT_HASHTAG_OPTIONS.MOST_RECENT;
  const isHashtagMedias = type === GALLERY_TYPES.HASHTAG;
  const localState = {
    ...storeState.expandReducer,
    accessToken,
    userId,
    isBusinessApp,
    isHashtagMedias,
    user,
    isRecent,
    medias: mediasByType[type],
    pagination: pageByType[type],
    stories: mediasByType[GALLERY_TYPES.STORY],
    posts: medias,
    isConnected,
  };

  localState.currentIndex = eData.idx;
  localState.currentMedia =
    localState.medias[localState.currentIndex].originalData ||
    localState.medias[localState.currentIndex];
  localState.appReducer = storeState.appReducer;
  localState.settingsReducer = storeState.settingsReducer;
  const settingsReducer = storeState.settingsReducer;
  const isV4 = await isInstagramV4(settingsReducer);
  if (isV4) {
    EXPAND_PARAMS.forEach((param) => {
      localState[param] = settingsReducer[param];
    });
  }

  const url = `${window.location.protocol}//${window.location.hostname}/ig_business_app/${route}`;

  const position = {
    origin: window.Wix.WindowOrigin.FIXED,
    placement: window.Wix.WindowPlacement.CENTER,
    x: 0,
    y: 0,
  };
  localStorage.setItem('state', JSON.stringify(localState));
  isNewWindow &&
    window.Wix.openPopup(
      url,
      '100%',
      '100%',
      position,
      () => {},
      window.Wix.Theme.BARE,
    );
};

/**
 * Updates story progress by index
 * @param {number} storyIndex
 * @param {number} progress
 */
export const updateStoryProgress = (storyIndex, progress) => {
  return {
    type: UPDATE_STORY_PROGRESS,
    storyIndex,
    progress,
  };
};

/**
 * When load expand get all data
 * @param {Function} dispatch
 */
export const onLoadExpand = ({ toLoadStories }) => (dispatch) => {
  const state = JSON.parse(localStorage.getItem('state'));
  localStorage.removeItem('state');

  const {
    isBusinessApp,
    medias,
    comments,
    currentIndex,
    commentsPagination,
    loadingComments,
    accessToken,
    userId,
    mediaLinks,
    loadingMediaLinks,
    isHashtagMedias,
    isConnected,
  } = state;

  dispatch({
    type: SET_APP_STATE,
    payload: state.appReducer,
  });
  dispatch({
    type: ON_TEXT_CHANGE,
    payload: state.settingsReducer,
  });

  delete state.appReducer;

  dispatch({
    type: SET_EXPAND_STATE,
    payload: state,
  });

  if (!isHashtagMedias) {
    _getExpandMediasDetalies(
      dispatch,
      medias,
      comments,
      currentIndex,
      commentsPagination,
      loadingComments,
      accessToken,
      userId,
      isBusinessApp,
      mediaLinks,
      loadingMediaLinks,
      isConnected,
    );
  }
  toLoadStories && dispatch({ type: SET_STORIES });
};

/**
 * Handling next arrow clicking.
 * @param {Function} dispatch
 * @param {Object} state
 */
export const onClickNextArrow = (dispatch, state) => {
  const {
    medias,
    currentIndex,
    pagination,
    isLodingMedias,
    accessToken,
    userId,
    isHashtagMedias,
    isBusinessApp,
    isRecent,
  } = state;

  const newIndex = currentIndex + 1;

  if (currentIndex >= medias.length) {
    return;
  }

  _updateCurrentMedia(dispatch, newIndex, state);

  loadMoreMedias(
    dispatch,
    newIndex,
    pagination,
    medias,
    isLodingMedias,
    accessToken,
    userId,
    isHashtagMedias,
    isBusinessApp,
    isRecent,
  );
};

/**
 * Handling prev arrow clicking.
 * @param {Function} dispatch
 * @param {Object} state
 */
export const onClickPrevArrow = (dispatch, state) => {
  const { currentIndex } = state;

  const newIndex = currentIndex - 1;

  if (newIndex < 0) {
    return;
  }

  _updateCurrentMedia(dispatch, newIndex, state);
};

export const updateCurrentMedia = (index) => (dispatch) => {
  const storeState = store.getState();
  const { medias } = storeState.expandReducer;
  const newMedia = medias[index].originalData || medias[index];

  dispatch({
    type: ON_CLICK_MEDIA,
    payload: {
      media: newMedia,
      index,
    },
  });
};

/**
 * Update media Selected
 * @param {Function} dispatch
 * @param {Number} newIndex - index of media
 * @param {Object} state
 */
const _updateCurrentMedia = (dispatch, newIndex, state) => {
  const {
    medias,
    comments,
    currentIndex,
    isBusinessApp,
    commentsPagination,
    loadingComments,
    accessToken,
    userId,
    mediaLinks,
    loadingMediaLinks,
    isHashtagMedias,
  } = state;

  const newMedia = medias[newIndex].originalData || medias[newIndex];

  dispatch({
    type: ON_CLICK_MEDIA,
    payload: {
      media: newMedia,
      index: newIndex,
    },
  });

  if (!isHashtagMedias) {
    _getExpandMediasDetalies(
      dispatch,
      medias,
      comments,
      currentIndex,
      commentsPagination,
      loadingComments,
      accessToken,
      userId,
      isBusinessApp,
      mediaLinks,
      loadingMediaLinks,
    );
  }
};

/**
 * When open expand check that has comments and links to all medias
 * @param {Function} dispatch
 * @param {Object} medias
 * @param {Object} comments
 * @param {Number} currentIndex
 * @param {Object} commentsPagination
 * @param {Object} loadingComments
 * @param {String} accessToken
 * @param {Number} userId
 * @param {Boolean} isBusinessApp
 * @param {Object} mediaLinks
 * @param {Object} loadingMediaLinks
 */
const _getExpandMediasDetalies = (
  dispatch,
  medias,
  comments,
  currentIndex,
  commentsPagination,
  loadingComments,
  accessToken,
  userId,
  isBusinessApp,
  mediaLinks,
  loadingMediaLinks,
  isConnected,
) => {
  const end =
    currentIndex + 10 > medias.length - 1
      ? medias.length - 1
      : currentIndex + 10;

  const start = currentIndex - 10 < 0 ? 0 : currentIndex - 10;

  for (let i = start; i <= end; i++) {
    const media = medias[i].originalData || medias[i];
    const mediaId = media.id;
    const mediaLink = media.permalink;
    // Check if nedd to get comments of media
    if (isBusinessApp && !comments[mediaId] && !loadingComments[mediaId]) {
      getCommentsByMediaId(
        dispatch,
        mediaId,
        commentsPagination,
        accessToken,
        userId,
        !isConnected,
      );
    }

    // Check if need to get link media
    if (!mediaLinks[mediaId] && !loadingMediaLinks[mediaId]) {
      getMediaLinks(
        dispatch,
        mediaId,
        mediaLink,
        accessToken,
        userId,
        isBusinessApp,
        isConnected,
      );
    }
  }
};
